import { render, staticRenderFns } from "./AccountantView.vue?vue&type=template&id=6dc8075c&scoped=true"
import script from "./AccountantView.vue?vue&type=script&lang=js"
export * from "./AccountantView.vue?vue&type=script&lang=js"
import style0 from "./AccountantView.vue?vue&type=style&index=0&id=6dc8075c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc8075c",
  null
  
)

export default component.exports